module.exports = __webpack_public_path__ + "static/img/main.7ea9adc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/14/main.png
// module id = Exo5
// module chunks = 1